/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Modal, Icon, Item } from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import $ from 'jquery';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import WithRouter from '../Extensions/WithRouter';

class ScannedFilesInfoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMSF: props.isOpenMSF,
      componentFiles: [],
    };
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const { isOpenMSF } = this.state;
    const { scannedFileIds, ufid } = this.props;
    $(document).on('mouseover', '.modal_popup_wrap .modal_popup .title  span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    $(document).on('mouseover', '.modal_popup_wrap .modal_popup .content', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    $(document).on('mouseover', '.modal_popup_wrap .modal_popup .header', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    if (isOpenMSF) {
      this.getComponentFiles(ufid, scannedFileIds);
    }
  }

  componentDidUpdate(prevProps) {
    const { isOpenMSF, scannedFileIds, ufid } = this.props;

    if (isOpenMSF !== prevProps.isOpenMSF) {
      this.setState({
        isOpenMSF,
        componentFiles: [],
        isLoading: false,
      }, () => {
        if (isOpenMSF) {
          this.getComponentFiles(ufid, scannedFileIds);
        }
      });
    }
  }

  componentWillUnmount() {
  }

  getComponentFiles = (ufid, scannedFileIds) => {
    const obj = {
      scanned_file_ids: scannedFileIds,
    };
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getComponentFiles(ufid, obj)
        .then((response) => {
          const data = response.response.map((item) => {
            return convertPropertiesToCamelCase(item);
          });
          this.setState({
            isLoading: false,
            componentFiles: data,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  };

  closeModal(e) {
    e.preventDefault();
    this.props.closeModal();
  }

  render() {
    const {
      isLoading,
      componentFiles,
      isOpenMSF,
    } = this.state;

    const { translate } = this.props;

    const getModalContent = () => {
      if (isLoading) {
        return (
          <div className="modal_popup_wrap file_info_wrap">
            <div className="modal_popup_box file_info_box">
              <div className="modal_popup file_info component_files">
                <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                  <Loader />
                </div>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div className="modal_popup_wrap file_info_wrap">
          <div className="modal_popup_box file_info_box">
            <div className="modal_popup file_info component_files">
              <h2 className="title">
                <span>
                  {translate('contents_header.link_header.scanned_files')}
                </span>
                <a className="close_button" onClick={this.closeModal}>
                  <img src={closeBtn} alt="" />
                </a>
              </h2>
              <Scrollbars
                renderTrackHorizontal={() => {
                  return <div />;
                }}
                renderThumbHorizontal={() => {
                  return <div />;
                }}
                autoHeight
                autoHeightMin={350}
                autoHeightMax={350}
              >
                <div className="popup_content">
                  {
                    componentFiles.length !== 0
                      && componentFiles.map((item) => {
                        return (
                          <div className="popup_content_item component_files" key={item.scannedFileId}>
                            <Item.Group>
                              <Item>
                                <Item.Header>
                                  <Icon className="file outline" />
                                  {item.scannedFile}
                                </Item.Header>
                              </Item>
                              <Item style={{ paddingLeft: '15px' }}>
                                <Item.Header className="sub_title">{translate('contents_header.link_header.parent_name')}</Item.Header>
                                <Item.Content>{item.parentName}</Item.Content>
                              </Item>
                              <Item style={{ paddingLeft: '15px' }}>
                                <Item.Header className="sub_title">{translate('contents_header.link_header.path')}</Item.Header>
                                <Item.Content>{item.path}</Item.Content>
                              </Item>
                              <Item style={{ paddingLeft: '15px' }}>
                                <Item.Header className="sub_title">{translate('contents_header.link_header.language')}</Item.Header>
                                <Item.Content>{item.language}</Item.Content>
                              </Item>
                              <Item style={{ paddingLeft: '15px' }}>
                                <Item.Header className="sub_title">{translate('contents_header.link_header.sha1')}</Item.Header>
                                <Item.Content>{item.sha1}</Item.Content>
                              </Item>
                              <Item style={{ paddingLeft: '15px' }}>
                                <Item.Header className="sub_title">{translate('contents_header.link_header.sha256')}</Item.Header>
                                <Item.Content>{item.sha256}</Item.Content>
                              </Item>
                              <Item style={{ paddingLeft: '15px' }}>
                                <Item.Header className="sub_title">{translate('contents_header.link_header.scan_method')}</Item.Header>
                                <Item.Content>{item.matchType}</Item.Content>
                              </Item>
                            </Item.Group>
                          </div>
                        );
                      })
                  }
                </div>
              </Scrollbars>
              <div className="button_wrap">
                <a onClick={this.closeModal} className="center_button">{translate('modal.button.close')}</a>
              </div>
            </div>
          </div>
        </div>
      );
    };
    return (
      <Modal open={isOpenMSF} onClose={this.closeModal}>
        {getModalContent()}
      </Modal>
    );
  }
}

export default WithRouter(ScannedFilesInfoModal);
